import { render } from "./BancoForm.vue?vue&type=template&id=612c19c1&scoped=true"
import script from "./BancoForm.vue?vue&type=script&lang=js"
export * from "./BancoForm.vue?vue&type=script&lang=js"

import "./BancoForm.vue?vue&type=style&index=0&id=612c19c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612c19c1"]])

export default __exports__